/**
 * F-188 / T-165-002 — single source of truth for the meeting-link CTA URL.
 *
 * The production calendar URL literal may only ever appear in this file
 * (grep guard: `3q2vJnS53anxDGbg6` must not appear in components).
 * Override per environment with REACT_APP_MEETING_LINK_URL.
 *
 * Mirrors LP src/config/meeting-link.js (T-165-001): plan_type is always
 * appended; utm_campaign / ab_variant only when supplied.
 */

export const DEFAULT_MEETING_LINK_URL = 'https://calendar.app.google/EVFGmvGSuHpv2YdX9';

export type MeetingPlanType = 'free' | 'commitment' | 'enterprise';

/** Self-serve (free) / sales-qualified (commitment) / 1:1 (enterprise) routing buckets. */
export function normalizeMeetingPlanType(tier?: string | null): MeetingPlanType {
  const t = String(tier || '').trim().toLowerCase();
  if (t === 'enterprise') return 'enterprise';
  if (['essentials', 'professional', 'commitment', 'pro', 'trial'].includes(t)) return 'commitment';
  return 'free';
}

export function getMeetingLinkUrl(opts: {
  tier?: string | null;
  campaign?: string;
  abVariant?: string;
} = {}): string {
  const base =
    (process.env.REACT_APP_MEETING_LINK_URL || '').trim() || DEFAULT_MEETING_LINK_URL;
  const params = new URLSearchParams();
  params.set('plan_type', normalizeMeetingPlanType(opts.tier));
  if (opts.campaign) params.set('utm_campaign', opts.campaign);
  if (opts.abVariant) params.set('ab_variant', opts.abVariant);
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}${params.toString()}`;
}
